export const Status = {
  BAD_REQUEST: 400,
  ACCESS_DENIED: 403,
  FORBIDDEN: 403, // 백엔드 코드가 FORBIDDEN으로 매핑해놨더라구요..? ACCESS_DENIED라고 매핑하지 않아서 추가해놨습니다.
  INVALID_USER: 401,
  NOT_FOUND: 404,
  ANONYMOUS: 406,
  TIMEOUT: 408,
  CONNECTION_TIMEOUT: 500,
  INTERNAL_SERVER_ERROR: 500,
}
